/*eslint-disable */

import axios from 'axios';
import {
  bus
} from '@/main';
import headerAfterLogin from '../headerAfterLogin/index';
import headerBeforeLogin from '../headerBeforeLogin/index';

export default {
  name: 'app_header',
  components: {
    'header-before-login': headerBeforeLogin,
    'header-after-login': headerAfterLogin
  },
  props: [],
  data() {
    return {
      isLoggin: ''
    }
  },
  computed: {
    checkUserLogin() {
      return this.isLoggin = this.$store.getters.isAuthenticated
    }
  },

  mounted() {

    // Interceptor
    /*axios.interceptors.response.use((response) => {
      return response;
    }, function(error) {
      console.log(error.status);
      let errorcode = error.response.data;
      if (error.response.data.code == 1000 || error.statusText == 'Bad Request') {
        if (error.response.data.data.email == 'This field must be unique.') {
          toast.error('Email must be unique');
        }
      }
      if (error.response.status == 400 || error.statusText == 'Bad Request') {
        toast.error(error.response.data.non_field_errors);
      }
      if (error.response.status == 401 || error.statusText == 'Unauthorized') {

        toast.error('Sorry, You are not authorized for it');
        store.dispatch('logout');
        localStorage.clear();
        router.push('login');
      }

      if (error.response.status == 403 || error.statusText == 'Forbidden') {

        toast.error('Sorry, You are not authorized for it');
        store.dispatch('logout');
        router.push('login');
      }
      if (error.response.status == 415) {
        toast.error('Media not supported');
      }
      return Promise.reject(error.response);
    });*/
  },
  methods: {

  },
  updated() {

  },
  created() {},
  watch: {
    checkUserLogin() {
      return this.$store.getters.isAuthenticated
    }
  }
}